import React, { Component } from 'react';
import { zones, zoneMap } from './fast-sensor-helper';
export class TriggerFastSensorDwellTime extends Component {
  render() {
    return <div>
        <div className="form-group">
          <label>Zone</label>
          <select className="form-control">
            {zones.map(zone => <option key={zone} value={zone}>
                {zoneMap[zone]}
              </option>)}
          </select>
        </div>
        <div className="form-group">
          <label>Dwell Time</label>
          <input type="text" className="form-control" placeholder="Choose Dwell Time" />
        </div>
      </div>;
  }
}